import { OrderDocumentType } from 'src/types/enums';
import { useTranslation } from '../../../contexts/translation-context';
import { ButtonSize } from '../../../components/button/BaseButton';
import { OrderDocumentTypeToTranslationKey } from '../../order/utils/document-validation';
import { CarrierCmrUploaderButton } from './CarrierCmrUploaderButton';

interface Props {
  carrierId: number;
  orderId: string;
  /** The document types this order requires, in the order they should be offered. */
  types: OrderDocumentType[];
  size?: ButtonSize;
  disableUpload?: boolean;
  onUploaded: (type: OrderDocumentType) => Promise<void>;
}

/**
 * One upload button per required document type, each labelled with the document
 * it takes. Nothing is hidden behind a menu: the buttons themselves are how a
 * carrier learns which documents this customer expects.
 */
export const CarrierPortalDocsUploadButtons: React.FC<Props> = ({
  carrierId,
  orderId,
  types,
  size,
  disableUpload,
  onUploaded,
}) => {
  const { i18n } = useTranslation();
  const options = types.length ? types : [OrderDocumentType.Cmr];

  return (
    <>
      {options.map((type) => (
        <CarrierCmrUploaderButton
          key={type}
          carrierId={carrierId}
          orderId={orderId}
          type={type}
          buttonLabel={i18n(OrderDocumentTypeToTranslationKey[type])}
          size={size}
          disableUpload={disableUpload}
          onUploaded={onUploaded}
        />
      ))}
    </>
  );
};
